export default __webpack_public_path__ + "static/media/gopher.a133b78b.svg";